import { IPromise } from 'angular';
import { call, put } from 'redux-saga/effects';
import * as _ from 'underscore';
import { Messages } from '../../../../codegen/Localize';
import { assertUnreachable } from '../../../../ts/helpers/TypescriptHelpers';
import { IContentInfo } from '../../../../ts/models/IContentInfo';
import { DataQualityService } from '../../../../ts/services/DataQualityService';
import { ModalInstance, ReactModalService } from '../../../../ts/services/ReactModalService';
import { requestFailed } from '../../../actions/RequestFailedAction';
import { requestSpaceContents } from '../../../actions/spaces/RequestSpaceContentsActions';
import { SetDataQualityAction } from '../../../actions/spaces/SetDataQualityAction';
import { DataQualityDialogProps, dataQualityDialogProps, DataQualityDialogState } from '../../../quality/DataQualityDialog';
import { ServiceLocator } from '../../../ServiceLocator';
import { isSubmitOrCancelButtonClicked, SubmitOrCancelButtonClicked } from '../../../utils/SubmitOrCancel';
import { replaceDatasourceIdWithConnectionIdForMixedContent } from '../SpacesSagaHelpers';
import { fetchContent, reloadSpaceIfUpdatingCurrentSpace } from './RefreshContentSagas';

export function* handleSetDataQuality(action: SetDataQualityAction) {
  try {
    let mutatableContentCopy: IContentInfo[] = [];
    mutatableContentCopy = yield call(replaceDatasourceIdWithConnectionIdForMixedContent, [action.item]);
    const first = _.first(mutatableContentCopy);
    const item: IContentInfo = yield fetchContent(first);

    const result: SubmitOrCancelButtonClicked | any = yield call(openDataQualityDialog, {type: action.type, item});

    if (isSubmitOrCancelButtonClicked(result)) {
      switch (result) {
        case SubmitOrCancelButtonClicked.cancelled: break;
        case SubmitOrCancelButtonClicked.submitted: {
          const maybeReloaded = yield call(reloadSpaceIfUpdatingCurrentSpace, [action.item]);
          if (!maybeReloaded) {
            yield put(requestSpaceContents());
          }
          break;
        }
        default: assertUnreachable(result);
      }
    }
  } catch(e) {
    yield put(requestFailed(e, Messages.errorUnknown()));
  }
}

export function openDataQualityDialog(action: SetDataQualityAction): IPromise<any> {
  let modalInstance: ModalInstance;
  const service: DataQualityService = ServiceLocator.get<DataQualityService>('DataQualityService');

  const indicator = _.first(action.item.dataQualityIndicators);
  const isUpdate = !!indicator && !!indicator.id;

  let contentItemId = action.item.id;
  if (action.item.contentType === 'table' || action.item.contentType === 'database') {
    contentItemId = action.item.vizportalId;
  }

  const addDataQualityWarning = (state: DataQualityDialogState) => {
    return service.addDataQualityWarning({
      contentName: action.item.name,
      contentId: contentItemId,
      contentType: action.item.contentType,
      ...state
    });
  };

  const updateDataQualityWarning = (state: DataQualityDialogState) => {
    return service.updateDataQualityWarning({
      contentName: action.item.name,
      id: indicator.id,
      ...state
    });
  };

  const setDataQualityWarning = isUpdate ? updateDataQualityWarning : addDataQualityWarning;

  const props: DataQualityDialogProps = {
    contentName: action.item.name,
    initial: isUpdate ? { ...indicator } : null,
    submit: (args: DataQualityDialogState) => setDataQualityWarning(args).then(() => modalInstance && modalInstance.close('submitted' as SubmitOrCancelButtonClicked)),
    cancel: () => modalInstance && modalInstance.close('cancelled' as SubmitOrCancelButtonClicked)
  };

  modalInstance = ReactModalService.open(dataQualityDialogProps(props));
  return modalInstance.result;
}
